const HTML_ESCAPES = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

/** Escapes text for HTML element content and quoted attribute values. */
export const escapeHTML = (value) =>
  String(value ?? "").replace(/[&<>"']/g, (token) => HTML_ESCAPES[token]);
